export default [
  'name',
  'email',
  { key: 'roles', label: 'Roles', sorter: false },
  'subscriptions',
  'created_at',
  { key: 'email_verified_at', label: 'Verified' },
  { key: 'action', label: '' }
]
